// extracted by mini-css-extract-plugin
module.exports = {"sidebarContent":"DevSidebarContent_sidebarContent__3kN61","sidebarContentItem":"DevSidebarContent_sidebarContentItem__2zxnA","active":"DevSidebarContent_active__2-ZvG"};